import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import NavTabs from '../../components/NavTabs';
import Sidebar from '../../components/SideBar';
import List from '../../components/List';
import Label from '../../components/Label';
import Button from '../../components/Button';
import tableIcons from '../../config/tableIcons';

import { Dialog, DialogActions, DialogContent } from '@material-ui/core';

import { Line } from './styles';
import EventsAPI from '../../services/event';
import ApproveDialog from './ApproveDialog';
import { toast } from 'react-toastify';
import { ContainerBox } from '../Event/Invites/styles';
import { config } from '../../config';

const Solicitations = () => {
    const [open, setOpen] = useState(false);
    const history = useHistory();

    const [solicitationData, setSolicitationData] = useState(null);
    const [dialogDelete, setDialogDelete] = useState(false);

    const handleOpenDelete = () => { setDialogDelete(true) };
    const handleCloseDelete = () => { setDialogDelete(false) };

    const handleOpen = () => { setOpen(true) };
    const handleClose = () => { 
        setSolicitationData(null)
        setOpen(false);
    };

    const handleApprove = () => {
        EventsAPI.updatePerson(solicitationData.id, {
            ...solicitationData,
            solicitation_approved: true,
            approved_at: new Date(),
            status_id: 4,
         })
        .then(resp => {
            if(resp.data && resp.data.data) {
                EventsAPI.sendConfirmationMail(
                    solicitationData.name,
                    solicitationData.email,
                    `${config.QRCODE_HOST}/?size=200x200&data=${solicitationData.id}`
                ).catch(err => console.log(err));
                toast.success('Aprovação concluída');
            } else toast.error('Desculpe ocorreu um erro');
            window.location.reload();
        })
        .catch(function(error) {
            console.log(error);
            toast.error('Desculpe ocorreu um erro. ' + JSON.stringify(error))
        });
    }

    const handleDeleteSolicitation = () => {
        EventsAPI.deletePerson(solicitationData.id)
        .then(resp => {
            if (resp) {
                console.log(resp.data)
                toast.success('Soliciatação excluida com sucesso!')
            }
            handleCloseDelete();
            window.location.reload();
        })
        .catch(function(error) {
            toast.error(error)
            handleCloseDelete();
        });
    }

    const columns = [
        { field: 'name', title: 'Nome' },
        { field: 'email', title: 'Email' },
        { field: 'company', title: 'Empresa' },
        { field: 'role', title: 'Cargo' },
        { field: 'phone', title: 'Telefone' },
        { field: 'status', title: 'Status' },
        { field: 'createdAt', title: 'Solicitado em' },
        { field: 'approved_at', title: 'Aprovado em' },
    ];

    const actions = [
        rowData => ({
            icon: tableIcons.Check,
            tooltip: 'Aprovar',
            onClick: (e, request) => {
                setSolicitationData(request);
                handleOpen();
            },
            disabled: rowData?.solicitation_approved ? true : false,
        }),
        rowData => ({
            icon: tableIcons.Delete,
            tooltip: 'Excluir Soliciatação',
            onClick: (e, request) => {
                setSolicitationData(request);
                handleOpenDelete();
            },
            disabled: rowData?.solicitation_approved ? true : false,
        }),
    ]

    const getRows = () => {
        return EventsAPI.getPeople()
        .then(resp => {
            if (!!resp.data) {
              const filtered = resp.data.data.filter(item => !item.is_guest)
              return filtered.map(item => {
                return { 
                    ...item, 
                    createdAt: new Date(item.createdAt).toLocaleString(),
                    status: item.solicitation_approved ? 'Aprovado' : 'Pendente',
                    approved_at: item.approved_at ? new Date(item.approved_at).toLocaleString() : 'Pendente',
                }
              });
            }
            return []
        })
        .catch(function(error) {
            return []
        });
    };

    const deleteDialog = (
        <>
            <Dialog
                onClose={handleCloseDelete}
                open={dialogDelete}
            >
                <ContainerBox className="content">
                    <DialogContent>
                        <Label
                            size='medium'
                            color='dark'
                            align='left'
                            weight='700'
                            padding='5px 0'
                        >
                            Excluir Soliciatação
                        </Label>
                        <Label
                            size='nano'
                            color='black'
                            align='left'
                        >
                            Tem certeza que deseja excluir a solicitação de <b>{solicitationData?.name}</b>?
                        </Label>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDelete} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleDeleteSolicitation} color="primary">
                            Excluir
                        </Button>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    )

    const data = [
        {
            name: 'Solicitações',
            content: (<List columns={columns} rows={[]} getRows={getRows} actions={actions} />)
        }
    ]

    const page = (
        <>
            <Line>
                <Label
                    className='first'
                    size='min'
                    color='dark'
                    align='left'
                    weight='500'
                >
                    Solicitações de Credenciamento
                </Label>
            </Line>
            {deleteDialog}
            <Dialog
                open={open}
                onClose={handleClose}
            >
                <DialogContent>
                    <ApproveDialog 
                        close={handleClose} 
                        handleApprove={handleApprove} 
                        solicitationData={solicitationData} 
                    />
                </DialogContent>
            </Dialog>
            <div style={{ maxWidth: '100%' }}>
                <NavTabs itens={data} />
            </div>
        </>
    )

    return ( <Sidebar current='Solicitações' content={page}/> )
}

export default Solicitations;
